import styled from "styled-components";
import { device } from "../../config/sizes";

export const PartnerWrapper = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  right: 3rem;
  font-size: 0.75em;
  text-align: center;
  opacity: 0.4;
  max-width: 800px;
  margin: 0 auto;

  a {
    color: black;

    :hover {
      text-decoration: none;
    }
  }

  @media ${device.tablet} {
    font-size: 0.75em;
    margin-bottom: 2em;
  }
`;
